const styles = theme => ({
    flex: {
        flex: 1
    },
    grow: {
        flexGrow: 1
    },
    card: {
        display: 'flex'
    },
    contentRoot: {
        padding: 0,
        background: theme.palette.background.default,
        scrollBehavior: 'smooth'
    },
    contentBody: {
        padding: theme.spacing(2)
    },
    contentBodyWide: {        
        padding: theme.spacing(2),
        maxWidth: 1200,
        margin: [[30, 'auto']],
        '@media(max-width:1400px)': {
            maxWidth: '100%',
            margin: [[30, 50]]
        }
    },
    actionRoot: {
        flex: 'none'
    },
    actionButtons: {
        marginRight: theme.spacing(2)
    },
    section: {
        marginBottom: theme.spacing(5)
    }
});

export default styles;